module.exports = __webpack_public_path__ + "img/LUB00010.a5d23330.png";